import * as React from 'react';
import { __ } from '../../helpers/TranslationService';

export const RecommendationList = (props) => {
    const { links } = props;

    const Link = (item) => (
        <section className="recommendation-list__link">
            <span>
                <a href={`${item.url}`} dangerouslySetInnerHTML={{ __html: item.title }}></a>
            </span>
            <span className="icon-arrowRight ml-2"></span>
        </section>
    );

    return (
        links &&
        links.length > 0 && (
            <>
                <h3 className="recommendation-list__title">{__('More Harbours', 'dreamlines')}</h3>

                <div className="recommendation-list__container recommendation-list__wrap">
                    {links.map((e, key) => (
                        <div key={key} className="recommendation-list__block">
                            <Link {...e} />
                        </div>
                    ))}
                </div>
            </>
        )
    );
};
